import envelop_opened from "./../../../../images/envelop_opened.png";
import "./VerifyNotification.css";
import { populateUserSession, resendVerifyMessage } from "../../../../services/authUtil";
import { useState } from "react";
import TalaeraSpinner from "../../../../components/TalaeraSpinner/TalaeraSpinner";
import { getErrorComponents, getSuccessComponents } from "../../../../services/util";
import { Trans, useTranslation } from "react-i18next";
import useUser from "hooks/useUser";
import { Navigate, useNavigate } from "react-router";
import TalaeraRoutes from "components/routes/TalaeraRoutes";

type Props = {
  email: string;
  token: string;
};

export const VerifyNotification = ({ email, token }: Props) => {
  const user = useUser();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [resendSuccess, setResendSuccess] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [redirect, setRedirect] = useState<string>();

  const handleResend = () => {
    setErrors("");
    setLoading(true);
    resendVerifyMessage(
      { resend_verification_token: token },
      () => {
        setLoading(false);
        setResendSuccess(true);
      },
      (err: any) => {
        if (err?.statusCode === 404) {
          populateUserSession(
            () => {
              // Tiny hack, routes are not updated yet, so have to wait
              // for the next render iteration to redirect user to to the root.
              setRedirect(TalaeraRoutes.ROOT.path);
            },
            () => {
              navigate(TalaeraRoutes.SIGN_IN.path, {
                state: { error: t("Signup.VerifyNotification.alreadyVerified") },
              });
            }
          );
        } else {
          setErrors(err?.errors);
          setLoading(false);
        }
      }
    );
    return email;
  };

  if (redirect) {
    return <Navigate to={redirect!} replace />;
  }

  return (
    <div className="verify-notification-step">
      <h1 className="step-title">{t("Signup.Please check your email to verify")}</h1>
      <div className="verify-notification-content">
        <img src={envelop_opened} alt="verify-email" />
        <div className="verify-description">
          <Trans
            i18nKey={"Signup.checkMail"}
            values={{ email: email || user?.profile?.email }}
          >
            Check the email we sent to <b>{email || user?.profile?.email}</b> and click
            the link to verify your email address
          </Trans>
        </div>

        {resendSuccess && getSuccessComponents(t("Signup.Email verification resent"))}

        <div className="forget-question">{t("Signup.didNotEmail")}</div>
        {errors && getErrorComponents(errors)}
        {loading ? (
          <TalaeraSpinner />
        ) : (
          <div className="step-action full-width">
            <button className="btn btn-outline full-width" onClick={handleResend}>
              {t("Signup.Resend Verification")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
